module.exports = __webpack_public_path__ + "static/about_system_notification-950d6ad4a2cea1fe809ca3e53f9a7798.png";